<p-table [rowHover]="true" #dt dataKey="Id"  [value]="games" styleClass="p-datatable-gridlines p-datatable-striped p-datatable-sm" [paginator]="true"
    [rows]="25" [columns]="columns" [sortField]="'date'" [sortOrder]="-1">
	 <ng-template pTemplate="header" let-columns>
        <tr>
            <th *ngFor="let col of columns" [pSortableColumn]="col.sort ? col.field : false">
            	<div class="flex gap-1 align-items-center">
	                <span>{{ col.title }}</span>
	                <i *ngIf="col.tooltip" class="pi pi-info-circle" pTooltip="{{col.tooltip}}"></i>
	                <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
            	</div>
            </th>
        </tr>
        <tr>
            <th *ngFor="let col of columns">
        		<input *ngIf="col.filter" style="width: 150px;" pInputText type="text" (input)="dt.filter($event.target.value,col.field, 'contains')" placeholder="Filtrer par {{col.title}}" />
        	</th>
        </tr>
    </ng-template>
	<ng-template pTemplate="body" let-row let-rowIndex="rowIndex" let-columns="columns">
		<tr>
            <td *ngFor="let col of columns" [ngSwitch]="col.type" [ngClass]="{'text-center':col.type == 'checkbox'}">
                <span *ngSwitchCase="'string'">{{ row[col.field] }}</span>
                <span *ngSwitchCase="'date'">{{ row[col.field] | date:'shortDate'}}</span>
                <p-checkbox (onChange)="update(row,col.field)" *ngSwitchCase="'checkbox'" [(ngModel)]="row[col.field]" [trueValue]="1" [falseValue]="0" [binary]="true"></p-checkbox>
            </td>
        </tr>
	</ng-template>
</p-table>